import { render, staticRenderFns } from "./TableManagerTools.vue?vue&type=template&id=267e3111&"
import script from "./TableManagerTools.vue?vue&type=script&lang=ts&"
export * from "./TableManagerTools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports